import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Shared/Header/Header';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home/Home/Home';
import Footer from './components/Shared/Footer/Footer';
import Blogs from './components/Home/Blogs/Blogs';
import Login from './components/Home/Login/Login/Login';
import NotFound from './components/Shared/NotFound/NotFound';
import SignUp from './components/Home/Login/SignUp/SignUp';
import RequireAuth from './components/Home/Login/RequireAuth/RequireAuth'
import Inventory from './components/Home/Inventory/Inventory';
import ManageInventory from './components/Home/MangeInventory/ManageInventory';
import AddInventory from './components/Home/AddInventory/AddInventory';
import MyItems from './components/Home/MyItems/MyItems';
import 'react-toastify/dist/ReactToastify.css';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Dashboard from './components/Home/Dashboard/Dashboard';
import MakeAdmin from './components/Home/Dashboard/MakeAdmin';

function App() {

  useEffect(()=>{
    AOS.init()
  },[])
  return (
    <div>
      <Header></Header>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/blogs' element={<Blogs></Blogs>}></Route>
        <Route path='/login' element={<Login></Login>}></Route>
        <Route path='/signup' element={<SignUp></SignUp>}></Route>
        <Route path='/inventory/:id' element={
          <RequireAuth>
            <Inventory></Inventory>
          </RequireAuth>
        }></Route>
       
       
      
        <Route path='*' element={<NotFound></NotFound>}></Route>

      <Route path='/dashboard' element={<RequireAuth><Dashboard></Dashboard></RequireAuth>}>
        <Route index element={<AddInventory></AddInventory>}></Route>
        <Route path='makeAdmin' element={<MakeAdmin></MakeAdmin>}></Route>
        <Route path='myItems' element={<MyItems></MyItems>}></Route>
        <Route path='manageInventory' element={<ManageInventory></ManageInventory>}></Route>
      </Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
